module.exports = "pegasus_template/assets/rectoutline-facebook.png";